import { LeasingOfferStatus } from 'modules/types/LeasingOffer';
import { PagingParams } from 'modules/types/PagingParams';
import { pagingToParams } from 'modules/utils';
import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const getLeasingOffers = async (
  params: PagingParams & { leasingOfferStatus?: LeasingOfferStatus },
) => {
  const requestParams = pagingToParams(params);

  if (params.leasingOfferStatus) {
    requestParams.append('status', params.leasingOfferStatus);
  }

  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/leasing-offer`,
    { params: requestParams },
  );

  const {
    data: { content, totalPages },
  } = response;

  return {
    leasingOffers: content,
    totalPageCount: totalPages,
    page: params.page,
    status: params.leasingOfferStatus,
  };
};
